<script setup lang="ts">
withDefaults(
  defineProps<{
    isOnBackground?: boolean;
  }>(),
  {
    isOnBackground: false,
  },
);

const localePath = useLocalePath();
</script>

<template>
  <NuxtLink
    class="brand-link text-2xs"
    :to="localePath('index')"
    :class="{ 'is-on-background': isOnBackground }"
  >
    <img src="/icons/logo.svg" alt="" aria-hidden="true" />
    <div class="text">
      <span>{{ $t('brandName') }}</span>
      <span>{{ $t('brandSubline') }}</span>
    </div>
  </NuxtLink>
</template>

<style lang="scss" scoped>
.brand-link {
  display: flex;
  align-items: center;
  transform: translateY(0);
  transition: transform 0.25s ease-in-out;
  color: var(--base-color-foreground);
  text-decoration: none;

  @media (--vs) {
    gap: 0.5rem;
  }

  @media (--vl) {
    gap: 1rem;
  }

  &.is-on-background {
    color: var(--color-white);
  }
}

.brand-link > .text {
  display: flex;
  flex-direction: column;
}
</style>
